import React from 'react';
import { Box, CardActionArea, CardContent, Grid, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import {
    IconRuler2,
    IconCoins,
    IconWorld,
    IconBuildingBank,
    IconBuildingWarehouse,
    IconCreditCard,
    IconCalendarTime,
    IconSitemap,
    IconTags,
    IconLayoutGrid
} from '@tabler/icons';
import { useHistory } from 'react-router-dom';
import PageHeader from '../../../../../ui-component/extended/PageHeader';
import GlassCard from '../../../../../ui-component/extended/GlassCard';
import GradientIconBadge from '../../../../../ui-component/extended/GradientIconBadge';

const REFERENCES = [
    { title: 'Unidades de Medida', description: 'UN, KG, CX, LT...', icon: IconRuler2, gradient: 'blue', url: '/dashboard/config/references/units' },
    { title: 'Moedas', description: 'Real, Dólar, Euro...', icon: IconCoins, gradient: 'amber', url: '/dashboard/config/references/currencies' },
    {
        title: 'Geografia',
        description: 'Países, estados e municípios',
        icon: IconWorld,
        gradient: 'teal',
        url: '/dashboard/config/references/geography/countries'
    },
    { title: 'Bancos', description: 'Lista de bancos (FEBRABAN)', icon: IconBuildingBank, gradient: 'graphite', url: '/dashboard/config/references/banks' },
    {
        title: 'Agências Bancárias',
        description: 'Agências usadas nas contas bancárias',
        icon: IconBuildingWarehouse,
        gradient: 'graphite',
        url: '/dashboard/config/references/bank-agencies'
    },
    {
        title: 'Formas de Pagamento',
        description: 'Dinheiro, PIX, cartão, boleto...',
        icon: IconCreditCard,
        gradient: 'teal',
        url: '/dashboard/config/references/payment-methods'
    },
    {
        title: 'Condições de Pagamento',
        description: 'À vista, 30/60/90 dias...',
        icon: IconCalendarTime,
        gradient: 'coral',
        url: '/dashboard/config/references/payment-terms'
    },
    {
        title: 'Centros de Custo',
        description: 'Classificação por área da empresa',
        icon: IconSitemap,
        gradient: 'blue',
        url: '/dashboard/config/references/cost-centers'
    },
    {
        title: 'Categorias Financeiras',
        description: 'Classificação de contas a pagar/receber',
        icon: IconTags,
        gradient: 'coral',
        url: '/dashboard/config/references/financial-categories'
    }
];

const ReferencesHome = () => {
    const history = useHistory();

    return (
        <Box>
            <PageHeader
                icon={IconLayoutGrid}
                gradient="graphite"
                title="Cadastros Auxiliares"
                subtitle="Estruturas de apoio usadas em produtos, financeiro e cadastros"
            />

            <Grid container spacing={2}>
                {REFERENCES.map((item, index) => (
                    <Grid item xs={12} sm={6} md={3} key={item.url}>
                        <Box
                            component={motion.div}
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.35, delay: index * 0.05, ease: [0.4, 0, 0.2, 1] }}
                            sx={{ height: '100%' }}
                        >
                            <GlassCard accent="#636366" sx={{ height: '100%' }}>
                                <CardActionArea sx={{ height: '100%', p: 1 }} onClick={() => history.push(item.url)}>
                                    <CardContent>
                                        <GradientIconBadge icon={item.icon} gradient={item.gradient} size={48} />
                                        <Typography variant="h6" fontWeight={700} mt={2}>
                                            {item.title}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {item.description}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </GlassCard>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default ReferencesHome;
